
import { PaletteColorOptions } from '@mui/material/styles';
import { ThemeMode } from 'config';
import { PalettesProps } from '@ant-design/colors';
import { PaletteThemeProps } from 'types/theme';

export function Theme10(colors: PalettesProps, mode: ThemeMode): PaletteThemeProps {
  const { grey } = colors;

  const greyColors: PaletteColorOptions = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };

  const contrastText = '#000';

  let primaryColors = [
    '#FFF9E0',
    '#FFEFA8',
    '#FFE275', 
    '#FFD447', 
    '#F7C530',
    '#F2C94C', 
    '#D9A72E', 
    '#B7891B', 
    '#8A6A10', 
    '#5C4906' 
  ];

  if (mode === ThemeMode.DARK) {
    primaryColors = [
      '#3B2E03', 
      '#4C3A05', 
      '#6B5208', 
      '#8A6A10', 
      '#B7891B', 
      '#F2C94C', 
      '#F7D86E', 
      '#FFE89C', 
      '#FFF4CA', 
      '#FFFAE5' 
    ];
  }

  return {
    primary: {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      contrastText
    },
    grey: greyColors
  } as any;
}
